<template>
  <main
    class="main-content d-flex justify-content-center align-items-start p-4 overflow-auto mt-6"
    style="background-color: #f8f9fa"
  >
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-7">
          <!-- Detail Information Form Card -->
          <div class="card border-0 shadow-sm mb-4">
            <div class="card-body p-4">
              <h5 class="mb-1">Detail Information</h5>
              <p class="text-muted small mb-4">
                All detail information about your business
              </p>

              <!-- General Error Message -->
              <div
                v-if="errors.general"
                class="alert text-white alert-danger mb-4"
              >
                {{ errors.general }}
              </div>

              <!-- Basic Information Section -->
              <div class="card mb-4">
                <div
                  class="card-header"
                  style="
                    background-color: #e8f5e9;
                    border-bottom: none;
                    padding: 0.75rem 1rem;
                  "
                >
                  <h6 class="mb-0 text-header">Basic Information</h6>
                </div>
                <div class="card-body" style="padding: 1rem">
                  <div class="form-group">
                    <label for="companyName" class="text-label-custom"
                      >Company Name</label
                    >
                    <span style="color: #ff3b30">*</span>
                    <argon-input
                      type="text"
                      id="companyName"
                      v-model="companyName"
                      placeholder="PT Maju Jaya Bersama"
                    />
                    <small v-if="errors.companyName" class="text-danger">{{
                      errors.companyName
                    }}</small>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="nib" class="text-label-custom"
                          >Business Registration Number (NIB)</label
                        >
                        <span style="color: #ff3b30">*</span>
                        <argon-input
                          type="text"
                          id="nib"
                          v-model="nib"
                          :maxlength="30"
                        />
                        <small v-if="errors.nib" class="text-danger">{{
                          errors.nib
                        }}</small>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="incorporationDate" class="text-label-custom"
                          >Incorporation Date</label
                        >
                        <span style="color: #ff3b30">*</span>
                        <argon-input
                          type="date"
                          id="incorporationDate"
                          placeholder="DD/MM/YYYY"
                          v-model="incorporationDate"
                        />
                        <small
                          v-if="errors.incorporationDate"
                          class="text-danger"
                          >{{ errors.incorporationDate }}</small
                        >
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-0">
                    <label for="taxId" class="text-label-custom"
                      >Company Tax ID</label
                    >
                    <span style="color: #ff3b30">*</span>
                    <argon-input
                      type="text"
                      id="taxId"
                      v-model="taxId"
                      :maxlength="20"
                    />
                    <small v-if="errors.taxId" class="text-danger">{{
                      errors.taxId
                    }}</small>
                  </div>
                </div>
              </div>

              <!-- Company Address Section -->
              <div class="card mb-4">
                <div
                  class="card-header"
                  style="
                    background-color: #e8f5e9;
                    border-bottom: none;
                    padding: 0.75rem 1rem;
                  "
                >
                  <h6 class="mb-0 text-header">Company Address</h6>
                </div>
                <div class="card-body" style="padding: 1rem">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="address" class="text-label-custom"
                          >Address</label
                        >
                        <span style="color: #ff3b30">*</span>
                        <argon-input
                          type="text"
                          id="address"
                          v-model="companyAddress"
                          :maxlength="255"
                        />
                        <small
                          v-if="errors.companyAddress"
                          class="text-danger"
                          >{{ errors.companyAddress }}</small
                        >
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="stateProvince" class="text-label-custom"
                          >State/Province</label
                        >
                        <span style="color: #ff3b30">*</span>
                        <div class="select-with-icon position-relative">
                          <select
                            class="form-control"
                            id="stateProvince"
                            v-model="stateProvince"
                          >
                            <option value="" selected disabled>
                              Select State/Province
                            </option>
                            <option
                              v-for="province in listProvinces"
                              :key="province"
                              :value="province.nama_provinsi"
                            >
                              {{ province.nama_provinsi }}
                            </option>
                          </select>
                          <img
                            src="../../../public/assets/icons/ic_dropdown.svg"
                            alt="icon"
                            class="select-icon"
                          />
                        </div>
                        <small
                          v-if="errors.stateProvince"
                          class="text-danger"
                          >{{ errors.stateProvince }}</small
                        >
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="city" class="text-label-custom">City</label>
                        <span style="color: #ff3b30">*</span>
                        <div class="select-with-icon position-relative">
                          <select class="form-control" id="city" v-model="city">
                            <option value="" selected disabled>
                              Select City
                            </option>
                            <option
                              v-for="cityOption in cities"
                              :key="cityOption"
                              :value="cityOption.nama_kab_kota"
                            >
                              {{ cityOption.nama_kab_kota }}
                            </option>
                          </select>
                          <img
                            src="../../../public/assets/icons/ic_dropdown.svg"
                            alt="icon"
                            class="select-icon"
                          />
                        </div>
                        <small v-if="errors.city" class="text-danger">{{
                          errors.city
                        }}</small>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group mb-0">
                        <label for="postcode" class="text-label-custom"
                          >Postcode</label
                        >
                        <span style="color: #ff3b30">*</span>
                        <argon-input
                          type="text"
                          id="postcode"
                          v-model="postcode"
                          :maxlength="5"
                        />
                        <small v-if="errors.postcode" class="text-danger">{{
                          errors.postcode
                        }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- User Information Section -->
              <div class="card mb-4">
                <div
                  class="card-header"
                  style="
                    background-color: #e8f5e9;
                    border-bottom: none;
                    padding: 0.75rem 1rem;
                  "
                >
                  <h6 class="mb-0 text-header">User Information</h6>
                </div>
                <div class="card-body" style="padding: 1rem">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="fullname" class="text-label-custom"
                          >Fullname</label
                        >
                        <span style="color: #ff3b30">*</span>
                        <argon-input
                          type="text"
                          id="fullname"
                          placeholder="Joni Don"
                          v-model="fullname"
                        />
                        <small v-if="errors.fullname" class="text-danger">{{
                          errors.fullname
                        }}</small>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="email" class="text-label-custom"
                          >Email</label
                        >
                        <span style="color: #ff3b30">*</span>
                        <argon-input
                          type="email"
                          id="email"
                          placeholder="Joni@gmail.com"
                          v-model="email"
                        />
                        <small v-if="errors.email" class="text-danger">{{
                          errors.email
                        }}</small>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="title" class="text-label-custom">Title*</label>
                    <select class="form-control" id="title" v-model="title">
                      <option value="" selected disabled>Select Title</option>
                      <option
                        v-for="titleOption in titles"
                        :key="titleOption"
                        :value="titleOption"
                      >
                        {{ titleOption }}
                      </option>
                    </select>
                    <small v-if="errors.title" class="text-danger">{{
                      errors.title
                    }}</small>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="text-label-custom">Select Identity</label>
                        <span style="color: #ff3b30">*</span>
                        <div class="d-flex">
                          <div class="form-check mr-3">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="identityType"
                              id="ktp"
                              value="KTP"
                              v-model="identityType"
                            />
                            <label class="form-check-label" for="ktp"
                              >KTP</label
                            >
                          </div>
                          <div
                            class="form-check"
                            style="margin-left: 24px !important"
                          >
                            <input
                              class="form-check-input"
                              type="radio"
                              name="identityType"
                              id="passport"
                              value="Passport"
                              v-model="identityType"
                            />
                            <label class="form-check-label" for="passport"
                              >Passport</label
                            >
                          </div>
                        </div>
                        <small v-if="errors.identityType" class="text-danger">{{
                          errors.identityType
                        }}</small>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="uploadPhoto" class="text-label-custom"
                          >Upload Photo Identity
                        </label>
                        <span style="color: #ff3b30">*</span>
                        <div class="d-flex flex-column">
                          <div class="d-flex align-items-center mb-1">
                            <input
                              type="file"
                              class="form-control"
                              id="identityPhoto"
                              placeholder="3171065123456"
                              @change="handleFileChange"
                              accept=".jpg,.jpeg,.png,.pdf"
                            />
                          </div>

                          <div
                            v-if="pathFile && identityPhotoName"
                            class="d-flex align-items-center mt-2"
                          >
                            <span class="badge badge-success mr-2"
                              >✓ Uploaded</span
                            >
                            <a
                              v-if="pathFile"
                              href="#"
                              @click.prevent="viewExistingPhoto"
                              class="ml-2 text-primary"
                              >[View]</a
                            >
                          </div>
                        </div>
                        <small
                          v-if="errors.identityPhotoFile"
                          class="text-danger"
                          >{{ errors.identityPhotoFile }}</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="identityNumber" class="text-label-custom"
                          >Identity Number</label
                        >
                        <span style="color: #ff3b30">*</span>
                        <input
                          type="text"
                          class="form-control"
                          id="identityNumber"
                          v-model="identityNumber"
                          maxlength="16"
                        />
                        <small
                          v-if="errors.identityNumber"
                          class="text-danger"
                          >{{ errors.identityNumber }}</small
                        >
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="birthDate" class="text-label-custom"
                          >Date of Birth</label
                        >
                        <span style="color: #ff3b30">*</span>
                        <argon-input
                          type="date"
                          id="birthDate"
                          placeholder="DD/MM/YYYY"
                          v-model="birthDate"
                          :maxlength="255"
                        />
                        <small v-if="errors.birthDate" class="text-danger">{{
                          errors.birthDate
                        }}</small>
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-0">
                    <label for="userAddress" class="text-label-custom"
                      >Address</label
                    >
                    <span style="color: #ff3b30">*</span>
                    <input
                      type="text"
                      class="form-control"
                      id="userAddress"
                      v-model="userAddress"
                    />
                    <small v-if="errors.userAddress" class="text-danger">{{
                      errors.userAddress
                    }}</small>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-start mt-4">
                <button
                  class="btn btn-md btn-outline-secondary me-2"
                  @click="saveAndQuit"
                >
                  Save & Quit
                </button>
                <button
                  class="btn btn-md btn-primary"
                  @click="showContinueModal"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <Loading :isLoading="isLoading" />
</template>

<script>
import { useStore } from "vuex";
import Loading from "@/components/Loading";
import ArgonInput from "@/components/ArgonInput";
import { onBeforeUnmount, onBeforeMount } from "vue";
import { buildFormData } from "../../utils/param-builder";
import { saveDataCompany, getDataCompany } from "../../api/company";
import { getProvince, getCity } from "../../api/app";

export default {
  components: {
    ArgonInput,
    Loading,
  },
  data() {
    return {
      stepNumber: 1,
      merchantId: 0,
      companyName: "",
      nib: "",
      incorporationDate: "",
      companyAddress: "",
      taxId: "",
      stateProvince: "",
      city: "",
      postcode: "",
      fullname: "",
      email: "",
      title: "",
      identityType: "",
      identityNumber: "",
      birthDate: "",
      userAddress: "",
      identityPhotoFile: "",
      pathFile: "",
      identityPhotoName: "",
      previewUrl: "",
      fileType: "",
      showPreviewModal: false,
      states: ["Jakarta", "West Java", "East Java", "Bali", "Sumatra"],
      cities: [],
      titles: ["CEO", "Director", "Manager", "Staff", "Owner"],
      errors: {
        general: false,
        companyName: false,
        nib: false,
        incorporationDate: false,
        taxId: false,
        companyAddress: false,
        stateProvince: false,
        city: false,
        postcode: false,
        fullname: false,
        email: false,
        title: false,
        identityType: false,
        identityNumber: false,
        birthDate: false,
        userAddress: false,
        identityPhotoFile: false,
      },
      isLoading: false,
      listProvinces: [],
    };
  },
  watch: {
    stateProvince(newVal) {
      if (newVal) {
        this.listCities();
      }
    },
  },
  methods: {
    validate() {
      // Reset all errors
      Object.keys(this.errors).forEach((key) => {
        this.errors[key] = false;
      });

      let isValid = true;

      if (!this.companyName) {
        this.errors.companyName = "Company name is required";
        isValid = false;
      }
      if (!this.nib) {
        this.errors.nib = "Business Registration Number (NIB) is required";
        isValid = false;
      }
      if (!this.incorporationDate) {
        this.errors.incorporationDate = "Incorporation date is required";
        isValid = false;
      }
      if (!this.taxId) {
        this.errors.taxId = "Company Tax ID is required";
        isValid = false;
      }
      if (!this.companyAddress) {
        this.errors.companyAddress = "Company address is required";
        isValid = false;
      }
      if (!this.stateProvince) {
        this.errors.stateProvince = "State/Province is required";
        isValid = false;
      }
      if (!this.city) {
        this.errors.city = "City is required";
        isValid = false;
      }
      if (!this.postcode) {
        this.errors.postcode = "Postcode is required";
        isValid = false;
      }
      if (!this.fullname) {
        this.errors.fullname = "Fullname is required";
        isValid = false;
      }
      if (!this.email) {
        this.errors.email = "Email is required";
        isValid = false;
      }
      if (!this.title) {
        this.errors.title = "Title is required";
        isValid = false;
      }
      if (!this.identityType) {
        this.errors.identityType = "Identity type is required";
        isValid = false;
      }
      if (!this.identityNumber) {
        this.errors.identityNumber = "Identity number is required";
        isValid = false;
      }
      if (!this.birthDate) {
        this.errors.birthDate = "Date of birth is required";
        isValid = false;
      }
      if (!this.userAddress) {
        this.errors.userAddress = "User address is required";
        isValid = false;
      }

      // Check if we have either a new file upload or an existing file path
      if (
        (!this.identityPhotoFile || this.identityPhotoFile === false) &&
        !this.pathFile &&
        !this.identityPhotoName
      ) {
        this.errors.identityPhotoFile = "Identity photo is required";
        isValid = false;
      } else if (
        typeof this.identityPhotoFile === "object" &&
        this.identityPhotoFile !== null
      ) {
        // Check file size if it's a File object
        const fileSize = this.identityPhotoFile.size;
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (fileSize > maxSize) {
          const formattedSize = this.formatFileSize(fileSize);
          this.errors.identityPhotoFile = `File size (${formattedSize}) exceeds the 5MB limit`;
          isValid = false;
        }
      }

      if (!isValid) {
        this.$nextTick(() => {
          this.focusFirstError();
        });
      }

      return isValid;
    },
    focusFirstError() {
      // Map of error keys to corresponding input IDs
      const errorToInputMap = {
        companyName: "companyName",
        nib: "nib",
        incorporationDate: "incorporationDate",
        taxId: "taxId",
        companyAddress: "address",
        stateProvince: "stateProvince",
        city: "city",
        postcode: "postcode",
        fullname: "fullname",
        email: "email",
        title: "title",
        identityNumber: "identityNumber",
        birthDate: "birthDate",
        userAddress: "userAddress",
      };

      // Special cases for non-standard inputs
      const specialFocus = {
        identityType: () => {
          const ktpInput = document.getElementById("ktp");
          if (ktpInput) ktpInput.focus();
        },
        identityPhotoFile: () => {
          const photoInput = document.getElementById("identityPhoto");
          if (photoInput) photoInput.focus();
        },
      };

      // Find the first error and focus on its input
      for (const errorKey in this.errors) {
        if (this.errors[errorKey] && errorKey !== "general") {
          // Handle special cases
          if (specialFocus[errorKey]) {
            specialFocus[errorKey]();
            return;
          }

          // Handle standard inputs
          if (errorToInputMap[errorKey]) {
            const inputElement = document.getElementById(
              errorToInputMap[errorKey]
            );
            if (inputElement) {
              inputElement.focus();
              // Scroll to the element if needed
              inputElement.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
              return;
            }
          }
        }
      }
    },
    handleFileChange(event) {
      const file = event.target.files[0];

      if (file) {
        const fileType = file.type;
        const fileSize = file.size;
        // 5MB in bytes = 5 * 1024 * 1024
        const maxSize = 5 * 1024 * 1024;

        // Check file type - only allow jpg, png, pdf
        const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
        if (!allowedTypes.includes(fileType)) {
          this.errors.identityPhotoFile =
            "Only JPG, PNG, or PDF files are allowed";
          // Focus on the file input
          this.$nextTick(() => {
            const fileInput = document.getElementById("identityPhoto");
            if (fileInput) {
              fileInput.focus();
            }
          });
          return;
        }

        // Check file size
        if (fileSize > maxSize) {
          const formattedSize = this.formatFileSize(fileSize);
          this.errors.identityPhotoFile = `File size (${formattedSize}) exceeds the 5MB limit`;
          // Focus on the file input
          this.$nextTick(() => {
            const fileInput = document.getElementById("identityPhoto");
            if (fileInput) {
              fileInput.focus();
            }
          });
          return;
        }

        this.identityPhotoFile = file;
        this.previewUrl = URL.createObjectURL(file);
        this.fileType = fileType;
        this.showPreviewModal = true;

        // Clear path file and photo name when uploading a new file
        this.pathFile = null;
        this.identityPhotoName = "";

        // Clear any previous error
        this.errors.identityPhotoFile = false;
      }
    },
    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },
    async submitDetailForm(type = "submit") {
      if (!this.validate()) {
        return;
      }

      this.isLoading = true;

      try {
        const body = {
          merchant_id: this.merchantId,
          step_number: this.stepNumber,
          nib: this.nib,
          incorporation_date: this.incorporationDate,
          tax_id: this.taxId,
          address: this.companyAddress,
          state: this.stateProvince,
          city: this.city,
          postcode: this.postcode,
          fullname: this.fullname,
          title: this.title,
          identity_type: this.identityType,
          identity_number: this.identityNumber,
          date_of_birth: this.birthDate,
          user_address: this.userAddress,
          type: type, // New variable for tracking save vs submit
        };

        // Handle identity photo
        if (
          typeof this.identityPhotoFile === "object" &&
          this.identityPhotoFile !== null
        ) {
          // New file upload
          console.log("Using newly uploaded file");
          body.identity_photo = this.identityPhotoFile;
        } else if (this.pathFile) {
          // Create a dummy file since we can't fetch the remote URL (CORS issues)
          console.log("Creating dummy file for existing photo");

          try {
            // Create a small 1x1 pixel empty JPG as a placeholder
            const base64Data =
              "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAr/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AL+AAf/Z";
            const byteString = atob(base64Data.split(",")[1]);
            const mimeString = base64Data
              .split(",")[0]
              .split(":")[1]
              .split(";")[0];

            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }

            const blob = new Blob([ab], { type: mimeString });
            const dummyFile = new File(
              [blob],
              this.identityPhotoName || "existing_photo.jpg",
              { type: "image/jpeg" }
            );

            // Use the dummy file as our identity_photo
            body.identity_photo = dummyFile;

            // Also pass URL and name for the backend to know we're keeping the existing file
            body.identity_photo_url = this.pathFile;
            if (this.identityPhotoName) {
              body.identity_photo_name = this.identityPhotoName;
            }
            body.keep_existing_photo = "true";
          } catch (err) {
            console.error("Error creating dummy file:", err);
            // If creating a dummy file fails, just send the URL
            body.identity_photo_url = this.pathFile;
            if (this.identityPhotoName) {
              body.identity_photo_name = this.identityPhotoName;
            }
            body.keep_existing_photo = "true";
          }
        }

        const formData = buildFormData(body);

        const response = await saveDataCompany(formData, this.stepNumber);

        if (response.errors && response.errors.identity_photo) {
          // If we get a specific error about identity photo, show it
          this.errors.identityPhotoFile = response.errors.identity_photo[0];
          return null;
        }

        return response;
      } catch (error) {
        console.error("Error during form submission:", error);
        // Show error as a field message rather than a popup
        this.errors.general = "An unexpected error occurred. Please try again.";

        // Focus to the top of the form
        this.$nextTick(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        });
        return null;
      } finally {
        this.isLoading = false;
      }
    },
    async saveAndQuit() {
      const response = await this.submitDetailForm("save");
      if (response?.status === "success") {
        this.$router.push("/home");
      }
    },
    async showContinueModal() {
      const response = await this.submitDetailForm("submit");
      if (response?.status === "success") {
        this.$router.push("/company-document");
      }
    },
    async fetchData() {
      this.isLoading = true;
      try {
        const response = await getDataCompany(this.merchantId, this.stepNumber);
        if (response.status === "success") {
          this.companyName = response.data.company_name;
          this.nib = response.data.nib;
          this.incorporationDate = response.data.incorporation_date;
          this.taxId = response.data.tax_id;
          this.companyAddress = response.data.address;
          this.stateProvince = response.data.state;
          this.city = response.data.city;
          this.postcode = response.data.postcode;
          this.fullname = response.data.fullname;
          this.email = response.data.email;
          this.title = response.data.title;
          this.identityType = response.data.identity_type;
          this.identityNumber = response.data.identity_number;
          this.birthDate = response.data.date_of_birth;
          this.userAddress = response.data.user_address;

          // Handle the identity photo
          if (response.data.identity_photo_url) {
            this.pathFile = response.data.identity_photo_url;

            // Store the photo name if available
            if (response.data.identity_photo_name) {
              this.identityPhotoName = response.data.identity_photo_name;
            }

            // Set a non-null value to pass validation - use true instead of an object
            this.identityPhotoFile = true;

            // Clear any previous file upload since we have a URL
            if (this.previewUrl) {
              URL.revokeObjectURL(this.previewUrl);
              this.previewUrl = "";
            }
          }
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
        this.errors.general = "Failed to load company data. Please try again.";
      } finally {
        this.isLoading = false;
      }
    },
    togglePreviewModal() {
      this.showPreviewModal = true;
    },
    closePreviewModal() {
      this.showPreviewModal = false;
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.fileType = "";
      }
    },
    viewExistingPhoto() {
      // Open the photo URL in a new tab if it's a direct URL
      if (this.pathFile) {
        // Check if it's a PDF based on the file name
        const isPdf =
          this.identityPhotoName &&
          (this.identityPhotoName.toLowerCase().endsWith(".pdf") ||
            this.pathFile.toLowerCase().endsWith(".pdf"));

        // For PDFs, directly open in a new tab
        if (isPdf) {
          window.open(this.pathFile, "_blank");
        } else {
          // For images, show in a modal or directly open
          window.open(this.pathFile, "_blank");
        }
      }
    },
    async listProvince() {
      try {
        const response = await getProvince();
        if (response.status === "success") {
          this.listProvinces = response.data;
        }
      } catch (error) {
        console.error("Error fetching province data:", error);
      }
    },
    async listCities() {
      try {
        const params = {
          province_name: this.stateProvince,
        };

        const response = await getCity(params);
        if (response.status === "success") {
          this.cities = response.data;
        }
      } catch (error) {
        console.error("Error fetching city data:", error);
      }
    },
  },
  setup() {
    const store = useStore();
    const body = document.getElementsByTagName("body")[0];

    onBeforeMount(() => {
      const storedEmail = localStorage.getItem("merchant_email");
      const storedToken = localStorage.getItem("auth_token");

      if (storedEmail) {
        store.commit("auth/setEmail", storedEmail);
      }
      if (storedToken) {
        store.commit("auth/setToken", storedToken);
      }

      store.state.hideConfigButton = true;
      store.state.showSidenav = false;
      store.state.showFooter = false;
      body.classList.remove("bg-gray-100");
    });

    onBeforeUnmount(() => {
      store.state.hideConfigButton = false;
      store.state.showSidenav = true;
      store.state.showFooter = true;
      body.classList.add("bg-gray-100");
    });
  },
  mounted() {
    this.fetchData();
    this.listProvince();
    if (this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl);
    }
  },
  created() {
    this.merchantId = localStorage.getItem("merchantId");
    this.companyName = localStorage.getItem("merchantName");
  },
};
</script>

<style scoped>
.main-content {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.card {
  border-radius: 0.5rem;
  box-shadow: none !important;
  border: 1px solid #dae0e2;
}

.card-header {
  border-top-left-radius: 0.5rem !important;
  border-top-right-radius: 0.5rem !important;
}

.select-with-icon {
  position: relative;
}

.select-with-icon .select-icon {
  position: absolute;
  right: 12px;
  bottom: 8px;
  width: 16px;
  height: 16px;
  pointer-events: none; /* prevents icon from blocking click on select */
}
</style>
